import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import NavigateToLocation from 'components/NavigateToLocation';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {
      marginLeft: theme.spacing(2),
      color: theme.palette.greyBlue['700'],
      borderBottom: `solid 1px ${theme.palette.grey[300]}`,
      listStyleType: 'none',
      display: 'flex',

      '&:last-child': {
        borderBottom: 'none',
      },
      flexDirection: 'column',
    },
    listItemLink: {
      cursor: 'pointer',
      width: '100%',
      color: theme.palette.grey['700'],
    },
    linkText: {
      padding: theme.typography.pxToRem(16), // 1rem
      paddingRight: 0,
      paddingLeft: 0,
    },
    locationInfo: {
      paddingBottom: theme.typography.pxToRem(16), // 1rem
      color: theme.palette.grey['500'],
      fontSize: theme.typography.pxToRem(14), // 0.875rem
    },
  };
});

const SearchResultSingleListItem = ({
  className,
  isMobile,
  onClose,
  singleSearchResult,
  includeLocationInfo = false,
  onSuccessfulNavigateToSearchResult,
  ...props
}) => {
  const classes = useStyles();

  // Marker label is used but not page label because the page is not available.
  // See RP-5959. With Lunr, it may be possible to get the page in the same way as the marker.
  // In BookDocumentInformation.js, the marker is determined by parsing the document.
  const markerLabel = singleSearchResult?.marker?.label;

  return (
    <li className={classes.root} {...props}>
      <NavigateToLocation
        className={classes.listItemLink}
        onClick={(event) => {
          event.stopPropagation();
          onClose();
        }}
        onFocus={(event) => event.stopPropagation()}
        onSuccessfulNavigate={() =>
          onSuccessfulNavigateToSearchResult(singleSearchResult)
        }
        bookLocation={singleSearchResult.bookLocation}
        id={singleSearchResult.key}
      >
        <Typography
          variant="body1"
          className={`${classes.linkText} noTranslate`}
          dangerouslySetInnerHTML={{
            __html: singleSearchResult.snippet,
          }}
        ></Typography>
      </NavigateToLocation>
      {includeLocationInfo && markerLabel ? (
        <Typography
          variant="body1"
          className={`${classes.locationInfo} noTranslate`}
        >
          {markerLabel}
        </Typography>
      ) : null}
    </li>
  );
};

SearchResultSingleListItem.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  onClose: PropTypes.func,
  singleSearchResult: PropTypes.object,
  includeLocationInfo: PropTypes.bool,
  onSuccessfulNavigateToSearchResult: PropTypes.func,
};

export default SearchResultSingleListItem;
